<template>
    <el-autocomplete
        class="auto-complete-custom"
        v-model="keywords"
        :fetch-suggestions="querySearch"
        :placeholder="placeholder"
        @select="handleSelect"/>
</template>

<script>

export default {
  name: "AutoCompleteCustom",

  props: {
    placeholder: {
      type: String,
      default: "请输入关键字"
    },

    value: {
      type: Object,
      default: null
    },

    url: {
      type: String,
      default: ""
    },

    formatUrl: {
      type: Function,
      default: null
    },

    labelKey: {
      type: String,
      default: "name"
    }
  },

  data() {
    return {
      keywords: "",
      timeout: null
    };
  },

  methods: {
    async querySearch(keywords, cb) {
      let url = this.url;

      if (this.formatUrl) {
        url = this.formatUrl({ url, keywords });
      }
      else {
        url += `&keywords=${keywords}`;
      }

      try {
        let res = await this.$axios.post(url);

        let results = keywords
          ? res.map(item => {
            item.value =  item[this.labelKey];

            return item;
          }).filter(item => {
            item.value.toLowerCase().indexOf(keywords.toLowerCase() === 0);
          })
          : res;

        cb(results);
      }
      catch (e) {
        console.error(e);
      }
    },

    handleSelect(item) {
      this.$emit("input", item);
    }
  }
};
</script>

<style lang="scss">
.auto-complete-custom{
  .el-input__inner{
    height: 36px;
    line-height: 36px;
  }
}
</style>

